'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' });

var MovieCreation = function MovieCreation(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

MovieCreation = (0, _pure2.default)(MovieCreation);
MovieCreation.muiName = 'SvgIcon';

exports.default = MovieCreation;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/MovieCreation.js
// module id = 2628
// module chunks = 0